module.exports = __webpack_public_path__ + "static/media/noteWhite.7db66c91.svg";